import { X } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChatOverlay } from '@/components/ChatOverlay';
import { useChat } from '@/contexts/ChatContext';
import mixpanel from 'mixpanel-browser';

export function ChatBubble() {
  const location = useLocation();
  const { isOpen, openChat, closeChat } = useChat();

  // Don't show the bubble on the My Brain page
  if (location.pathname === '/my-brain') {
    return null;
  }

  const handleToggleChat = () => {
    if (isOpen) {
      closeChat();
    } else {
      openChat();
      mixpanel.track('open_chat', { source: 'bubble' });
    }
  };

  return (
    <>
      <div className="fixed bottom-6 right-6 z-40 group">
        <Button
          onClick={handleToggleChat}
          size="lg"
          className="h-18 w-18 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 bg-primary hover:bg-primary/90 p-0 overflow-hidden"
          aria-label={isOpen ? "Close chat" : "Open chat"}
        >
          <div className="relative w-full h-full flex items-center justify-center">
            {isOpen ? (
              <X className="h-7 w-7 group-hover:scale-110 transition-transform duration-200" />
            ) : (
              <img 
                src="https://i.imgur.com/vslBpBw.png" 
                alt="Jorge" 
                className="w-16 h-16 rounded-full object-cover group-hover:scale-110 transition-transform duration-200"
              />
            )}
          </div>
        </Button>
        
        {/* Tooltip - only show when closed */}
        {!isOpen && (
          <div className="absolute bottom-16 right-0 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
            <div className="bg-popover text-popover-foreground px-3 py-2 rounded-lg text-sm font-medium shadow-md whitespace-nowrap">
              Chat with Jorge's Second Brain
              <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-popover"></div>
            </div>
          </div>
        )}
      </div>

      {/* Chat Overlay */}
      <ChatOverlay isOpen={isOpen} onClose={closeChat} />
    </>
  );
} 